(function () {
    'use strict';

    // @ngInject
    Services.UrlMetadataService = function UrlMetadataService(Gon, $injector, $log) {
        this.addMetadata = function addMetadata(url) {
            try {
                const UsersManager = $injector.get('UsersManager');

                let delimiter;
                if (url.indexOf('?') === -1) {
                    delimiter = "?";
                } else {
                    delimiter = "&";
                }

                let user = UsersManager.getCurrUser();
                if (user && user._id) {
                    let metadataParams = `${delimiter}ctxu=${user._id}`;
                    let companyId = user.company_id;
                    if (!companyId && user.company) {
                        companyId = user.company._id;
                    }

                    if (companyId) {
                        metadataParams = `${metadataParams}&ctxc=${companyId}`;
                    }
                    url = `${url}${metadataParams}`;
                }
            } catch (e) {
                $log.error(e);
            }

            return url;
        };
    };
})();